( function( $ ) {
    $(document).ready(function () {
        $('.js-accordion').each(function () {
            const $accordion = $(this);
            const $toggleAccordion = $accordion.find('.js-toggleAccordion');

            $toggleAccordion.on('click', function() {
                const $accordionContent = $(this).next('.js-accordionContent');
                $accordion.find('.js-accordionContent').not($accordionContent).slideUp();
                $accordion.find('.js-toggleAccordion').not(this).removeClass('-active');
                $accordionContent.slideToggle();
                $(this).toggleClass('-active');
            });
        });
    });
} ) ( jQuery );